import React from 'react';

interface ScreenReaderOnlyProps<T extends React.ElementType> {
  as?: T;
  children: React.ReactNode | React.ReactNode[];
}

function ScreenReaderOnly<T extends React.ElementType = 'span'>({
  as,
  ...props
}: ScreenReaderOnlyProps<T> &
  Omit<React.ComponentPropsWithoutRef<T>, keyof ScreenReaderOnlyProps<T>>) {
  const Component = as || 'span';
  return <Component {...props} className="sr-only" />;
}

export default ScreenReaderOnly;
